/// <reference path="definitions/joinoperator.ts" />
/// <reference path="definitions/compareoperator.ts" />
/// <reference path="common/common.ts" />

namespace Cfnc {
    "use strict";
    interface IApp extends ng.IModule { }
    export interface ICfncRootScope extends ng.IRootScopeService {
        authenticating: Promise<any>;
    }

    // create the module and define its dependencies.
    var app: IApp = angular.module("app", [
        // angular modules 
        "ngResource",       // $resource for REST queries
        "ngAnimate",        // animations
        "ngSanitize",       // sanitizes html bindings (ex: sidebar.js)
        "ngRoute",           // routing
        "ngMessages",
        "ngCookies",
        "ngIdle",

        // custom modules 
        "common",

        // 3rd Party Modules
        "ui.bootstrap",
        "ui.utils",
        "ui.select",
        "ui.calendar",
        "uiGmapgoogle-maps",
        "restangular",
        "angular.filter",
        "ngFileUpload",
        "com.2fdevs.videogular",
        "vcRecaptcha",
        "highcharts-ng",
        "mgcrea.ngStrap",
        "slickCarousel"
    ]);

    // execute bootstrapping code and any dependencies.
    app.run(["$route", "$rootScope", "$http", "common", "routemediator", "$location", "$window", "$uibModalStack",
        ($route: ng.route.IRouteService, $rootScope: ICfncRootScope, $http: ng.IHttpService, common: ICommonFactory, routemediator, $location: angular.ILocationService, $window: angular.IWindowService, $uibModalStack: ng.ui.bootstrap.IModalStackService): void => {
            routemediator.setRoutingHandlers();

            var user = common.authentication.user;

            //$rootScope.$on("$routeChangeStart", (event, next: any) => {
            //    appInsights.startTrackPage(next.$$route.title);

            //});
            const path = $location.path();

            if (path == "/exclusive.html") {
                $location.url(`/exclusive.html${$location.hash()}`);
                $rootScope.$apply();
            }

            $rootScope.$on("$routeChangeSuccess", (event, current: any) => {
                var pagePath = `Cfnc${$location.url()}`;
                if ($window.ga) {
                    $window.ga('send', 'pageview', { page: $location.path() });
                }

                if (appInsights) {
                    if (localStorage[Cfnc.Security.CfncStorage.primaryConnection]) {
                        appInsights.stopTrackPage(current.$$route.title, pagePath, { "crmId": localStorage[Cfnc.Security.CfncStorage.primaryConnection] });
                    }
                    else
                        appInsights.stopTrackPage(current.$$route.title, pagePath);
                }

                //close all open modals
                $uibModalStack.dismissAll();
            });

            // Include $route to kick start the router.
            common.authentication.safeAccessToken().then((accessToken) => {
                $http.defaults.headers.common.Authorization = "Bearer " + accessToken;
            });

            $http.defaults.headers.common["Cache-Control"] = "no-cache";
            $http.defaults.headers.common.Pragma = "no-cache";
            $http.defaults.withCredentials = true;

            $rootScope.authenticating = common.authentication.checkLogin().then((user) => {
                if (user) {
                    common.authentication.broadcastLogin();
                }
            }, () => { });



        }]);
}
